import { Grid } from "@mui/material";
import Copyright from "./Copyright";
import React, { FC } from "react";
import { COLORS } from "../styles/colors";
import FooterMenu from "./FooterMenu";

/**
 * Component for the Drawer Footer. We need to use absolute positioning here,
 * since fixed won't work.
 */
const DrawerFooter: FC = () => {
  return (
    <Grid container flexDirection="column" alignContent="center">
      <Grid item>
        <FooterMenu
          gridContainerProps={{
            container: true,
            justifyContent: "center",
            alignContent: "end",
            alignItems: "end",
            flexWrap: "wrap",
            sx: { width: "98%", marginLeft: "1%", marginRight: "1%" },
            color: COLORS.tuv_r_black_30,
          }}
        />
      </Grid>
      <Grid item>
        <Copyright short />
      </Grid>
    </Grid>
  );
};

export default DrawerFooter;
